import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Otsi sobiv valik...

  <span style="color:#85c1dc;">**FI:**</span>
  Etsi sopiva vaihtoehto...

  <span style="color:#85c1dc;">**RU:**</span>
  Найдите подходящий вариант...
*/
/* @__NO_SIDE_EFFECTS__ */
const m1698 = msg(
  mf`Otsi sobiv valik...`,
  mf`Etsi sopiva vaihtoehto...`,
  mf`Найдите подходящий вариант...`,
)

export { m1698 as 'w.global.product_option.search' }